import { translationKeys } from '../translations';

export class OtherNameUtils {
  /**
   * check for other name
   * @returns translationKey for the given identifier
   */
  static abbreviateOtherName(identifier: string): string {
    let statement = '';
    switch (identifier) {
      case '66247': {
        statement = translationKeys.otherNameUtils.brand;
        break;
      }
      case '66248': {
        statement = translationKeys.otherNameUtils.model;
        break;
      }
      case '66249': {
        statement = translationKeys.otherNameUtils.type;
        break;
      }
      case '1342': {
        statement = translationKeys.otherNameUtils.other;
        break;
      }
      default: {
        statement = identifier;
        break;
      }
    }

    return statement;
  }
}
